import { copy } from "clipboard";

const phone = {
  state: {
    softPhone:false,
    softPhoneInfo:"",
    disNumber: [], //外显数组
    clock:"00:00:00",
    callColor: "",
    callStatus: "",
    //phone:'',//手机号
    callout:false ,//拨打
    hangup:false, //挂断
    ready:false, //就绪
    sleep:false , //小休
    unhold:false,//取出
    hold:true,//保持
    transfer:false, //转接
    answer:false, //接听
    consult:false, //咨询三方
    finish:false, //结束话后
    logout:false, //签出
    busy:false,//繁忙

    extension:false,
    showOrder:false, //弹屏
    autoReady:false,//自动就绪
    messageType:false, //福彩自动获取信息
    eslData:{}, //socket数据
    callInfo:{
      callee:"",//密文base64的||明文的手机号(用于呼叫接口)
      showCallee:"",//电话条显示的号码 带*的号码||明文手机号
      extendId:0,
      dialFlag:true,//是否可以手动输入号码
      copyFlag:false,//是否可以复制号码
    }
  },
  mutations: {
    SET_SOFTPHONE:(state,bool)=>{
      state.softPhone = bool;
    },
    SET_SOFTPHONE_INFO:(state,info)=>{
      state.softPhoneInfo = info;
    },
    SET_DISNUMBER:(state,arr)=>{
      state.disNumber = arr;
    },
    SET_CLOCK:(state,clock)=>{
      state.clock = clock;
    },
    SET_EXTENSION:(state,reg)=>{
      state.extension = reg;
    },
    SET_COLOR: (state, color) => {
      state.callColor = color;
    },
    SET_STATUS: (state, stauts) => {
      state.callStatus = stauts;
    },
    RESET: (state,payload) => {
      const { hangup, ready, sleep,callout,unhold,hold,transfer,answer,consult,finish,logout,busy} = payload;
      state.hangup = hangup,
      state.ready = ready;
      state.sleep = sleep;
      state.callout = callout;
      state.unhold = unhold;
      state.hold = hold;
      state.transfer = transfer;
      state.answer = answer;
      state.consult = consult;
      state.finish = finish;
      state.logout = logout;
      state.busy = busy;
    },
    SET_PHONE:(state, phone)=>{
      state.phone = phone;
    },
    SET_ORDER:(state, showOrder)=>{
      state.showOrder = showOrder;
    },
    SET_AUTOREADY:(state, autoReady)=>{
      state.autoReady = autoReady;
    },
    SET_AUTO_MESSAGE:(state, messageType)=>{
      state.messageType = messageType;
    },
    SET_ESLDATA:(state,object)=>{
      state.eslData = object;
    },
    SET_CALL_INFO:(state,callInfo)=>{
      state.callInfo = callInfo
    },
  },
  actions: {
    modify({ commit }, msgType) {
      if(msgType=='READY'){// 空闲
        commit("SET_COLOR", "#32CD32");
        commit("SET_STATUS", "空闲");
        commit("RESET",{hangup:false,ready:false,sleep:true,callout:true,unhold:false,hold:false,transfer:false,answer:true,finish:false,consult:false,logout:true,busy:true});
      }else if(msgType=="CALL_OUT_RINGING"){ // 坐席振铃
        commit("SET_COLOR", "#00BFFF");
        commit("SET_STATUS", "坐席振铃");
        commit("RESET",{hangup:true,ready:false,sleep:false,callout:false,unhold:false,hold:false,transfer:false,answer:true,finish:false,consult:false,logout:false,busy:false});
      }
      else if(msgType=="CALL_IN_RINGING"){ //呼入
        commit("SET_COLOR", "#00BFFF");
        commit("SET_STATUS", "坐席振铃");
        commit("RESET",{hangup:true,ready:false,sleep:false,callout:false,unhold:false,hold:false,transfer:false,answer:true,finish:false,consult:false,logout:false,busy:false});
        commit("SET_ORDER",true);
      }
      else if(msgType=="AGENT_ANSWER"){ //坐席应答
        commit("SET_COLOR", "#D2B48C");
        commit("SET_STATUS", "坐席应答");
        commit("RESET",{hangup:true,ready:false,sleep:false,callout:false,unhold:false,hold:false,transfer:false,answer:true,finish:false,consult:false,logout:false,busy:false});
      }else if(msgType=="CUS_RINGING"){//客户振铃
        commit("SET_COLOR", "#40E0D0");
        commit("SET_STATUS", "客户振铃");
        commit("RESET",{hangup:true,ready:false,sleep:false,callout:false,unhold:false,hold:false,transfer:false,answer:true,finish:false,consult:false,logout:false,busy:false});
      }else if(msgType=="TALKING"){ //通话中
        commit("SET_COLOR", "#3CB371");
        commit("SET_STATUS", "通话中");
        commit("RESET",{hangup:true,ready:false,sleep:false,callout:false,unhold:false,hold:true,transfer:true,answer:true,finish:false,consult:true,logout:false,busy:false});
      }else if(msgType=="CALL_AFTER"){//话后
        commit("SET_COLOR", "#FF0000");
        commit("SET_STATUS", "话后");
        commit("RESET",{hangup:false,ready:true,sleep:true,callout:true,unhold:false,hold:false,transfer:false,answer:true,finish:true,consult:false,logout:true,busy:false});
      }else if(msgType=="SLEEP"){// 小休
        commit("SET_COLOR", "#F56C6C");
        commit("SET_STATUS", "小休");
        commit("RESET",{hangup:false,ready:true,sleep:false,callout:true,unhold:false,hold:false,transfer:false,answer:true,finish:false,consult:false,logout:true,busy:true});
      }else if(msgType=="HOLDING"){// 保持
        commit("SET_COLOR", "#F56C6C");
        commit("SET_STATUS", "保持");
        commit("RESET",{hangup:true,ready:false,sleep:false,callout:false,unhold:true,hold:false,transfer:false,answer:true,finish:false,consult:false,logout:true,busy:false});
      }else if(msgType=="OFF_LINE"){//签出
        commit("SET_COLOR", "#606266");
        commit("SET_STATUS", "离线");
        commit("RESET",{hangup:false,ready:true,sleep:false,callout:false,unhold:false,hold:false,transfer:false,answer:true,finish:false,consult:false,logout:false,busy:false});
      }  else if(msgType=="CALL_BUSY"){// 繁忙
        commit("SET_COLOR", "#E6A23C");
        commit("SET_STATUS", "繁忙");
        commit("RESET",{hangup:false,ready:true,sleep:false,callout:false,unhold:false,hold:false,transfer:false,answer:true,finish:false,consult:false,logout:true,busy:false});
      }
    },
    phone({ commit }, phone) {
      commit("SET_PHONE", phone);
    },
    showOrder({ commit }, showOrder) {
      commit("SET_ORDER", showOrder);
    },
    timepiece({ commit }, clock){
      commit("SET_CLOCK", clock); 
    },
    autoReady({ commit }, autoReady){
      commit("SET_AUTOREADY", autoReady); 
    },
    messageType({ commit }, messageType){
      commit("SET_AUTO_MESSAGE", messageType); 
    },
    eslData({ commit }, eslData){
      commit("SET_ESLDATA", eslData);
    },
    callInfo({commit},callInfo){
      commit("SET_CALL_INFO",callInfo);
    }
  } 
};
export default phone;

